export default [
  {
    path: '/apps/familia-comercial/list',
    name: 'apps-familia-comercial-list',
    component: () => import('@/views/cadastros-gerais//familia-comercial/list/Index.vue'),
    meta: {
      pageTitle: 'Família Comercial',
      resource: 'AdminHanes',
    },
  },
  // {
  //     path: '/apps/familia-comercial/edit/:id',
  //     name: 'apps-familia-comercial-edit',
  //     component: () => import('@/views/cadastros-gerais/familia-comercial/familia-comercial-edit/GrupoEstoqueEdit.vue'),
  //     meta: {
  //         pageTitle: 'Editar Familia Comercial',
  //         resource: 'AdminHanes',
  //     },
  // },
];
